import React, { useEffect, useState } from 'react';
import { useNavigate,NavLink } from 'react-router-dom';
import { logout } from '../../actions/auth';
import { ConfigApp } from "../../controllers/ConfigApp";
import {encode as base64_encode} from 'base-64';
import { Button,User } from "@wfp/ui";
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';
  import {
    MainNavigation,
    MainNavigationItem,
    SubNavigation,
    SubNavigationHeader,
    SubNavigationLink
  } from "@wfp/ui";
  import { useDispatch, useSelector } from 'react-redux'
// Navigation component
export const NavBarHome = (props) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    
    const [imgIco, setImgIco] = useState('');
    const [imgIcoType, setImgIcoType] = useState('');
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }
    let ran = false;
    useEffect(() => {
        if (ran) return;
        const date = new Date();
        let oldDate = window.localStorage.getItem('login_token');
        if(!window.localStorage.getItem('login_token')){
            window.localStorage.setItem('login_token', date);
        }
        else{
            const examDate = new Date(oldDate); // Replace with your desired exam date
            const timeDifference = Math.abs(examDate - date);
            const daysRemaining = Math.ceil(timeDifference / (1000));
            if(daysRemaining < 1800){
                window.localStorage.setItem('login_token', date);
            }
            else{
                history( '/auth/login', {
                    replace: true
                });

                dispatch(logout(token));
            }
        }
            if(!window.localStorage.getItem('edufami_background')){
                ConfigApp("/appConfig").then((e)=>{
                // console.log(e)
                    e.forEach(a => {
                        // eslint-disable-next-line default-case
                        switch (a.name_key) {
                            case "edufami_background" :
                                window.localStorage.setItem('edufami_background', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_logo" :
                                window.localStorage.setItem('edufami_logo', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_icon" :
                                window.localStorage.setItem('edufami_icon', JSON.stringify(a));
                                setImgIco(a.image_value)
                                setImgIcoType(a.image_type)
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color1" :
                                window.localStorage.setItem('edufami_color1', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color2" :
                                window.localStorage.setItem('edufami_color2', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color3" :
                                window.localStorage.setItem('edufami_color3', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_color4" :
                                window.localStorage.setItem('edufami_color4', JSON.stringify(a));
                            break;
                            case "edufami_sponsor1" :
                                window.localStorage.setItem('edufami_sponsor1', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_sponsor2" :
                                window.localStorage.setItem('edufami_sponsor2', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_sponsor3" :
                                window.localStorage.setItem('edufami_sponsor3', JSON.stringify(a));
                            break;
                            // eslint-disable-next-line no-duplicate-case
                            case "edufami_sponsor4" :
                                window.localStorage.setItem('edufami_sponsor4', JSON.stringify(a));
                            break;
                            case "edufami_feedback_correct" :
                                window.localStorage.setItem('edufami_feedback_correct', JSON.stringify(a));
                            break;
                            case "edufami_feedback_incorrect" :
                                window.localStorage.setItem('edufami_feedback_incorrect', JSON.stringify(a));
                            break;
                            case "edufami_background_courses" :
                                window.localStorage.setItem('edufami_background_courses', JSON.stringify(a));
                            break;
                        }
                    })
                })
                .catch((e)=>{
                    console.warn(e);
                    document.getElementById('invalidMessage').classList.remove('hide');
                    
                });
            }
            else{
                setImgIco(JSON.parse(window.localStorage.getItem('edufami_icon')).image_value)
                setImgIcoType(JSON.parse(window.localStorage.getItem('edufami_icon')).image_type)
            }
            
            return () => (ran = true);
    }, [])
    const handleLogout = () => {
        history( '/auth/login', {
                    replace: true
                  });

        dispatch(logout(token));
    }

    //let nav_img = `${process.env.REACT_APP_PRD_URL}/assets/idWFPp.png`;
    return (
        <>
        {imgIco && <img className="img-ico" src = {(imgIcoType==='svg')?`data:image/svg+xml;base64,${base64_encode(imgIco)}`:`data:image/${imgIcoType}+xml;base64,${btoa(imgIco)}`} alt="Icon"/>}
            <MainNavigation className={props.classMenu}
            logo={<div className="wfp--main-navigation__logo"><span className="menu-titles">{transTxt.menu.edufami}</span></div>}
            >
            {/* <MainNavigation 
            logo={<div className="wfp--main-navigation__logo"><Link to="/"><img src={nav_img} alt="menu logo" className="menu-img" /></Link><span className="menu-title">EDUFAMI</span></div>}
            > */}
            <MainNavigationItem>
                <NavLink 
                    className="wfp--link"
                    to="/home"
                >
                {transTxt.menu.curso}
                </NavLink>
            </MainNavigationItem>
            <MainNavigationItem>
                <NavLink 
                    className="wfp--link"
                    to="/account"
                >
                {transTxt.menu.datos}    
                </NavLink>
            </MainNavigationItem>
            <MainNavigationItem>
                <NavLink 
                    className="wfp--link"
                    to="/certificates"
                >
                {transTxt.menu.certificados} 
                </NavLink>
            </MainNavigationItem>
            <MainNavigationItem>
                <NavLink 
                    className="wfp--link"
                    to="/progress"
                >
                {transTxt.menu.progreso}
                </NavLink>
            </MainNavigationItem>
                <MainNavigationItem
                    className="wfp--main-navigation__user"
                    subNavigation={
                    <SubNavigation>
                        <SubNavigationHeader>
                            <SubNavigationLink>
                                <Button className="nav-item nav-link btn"
                                    onClick={ handleLogout }
                                > 
                                    {transTxt.menu.cerrar}
                                </Button>
                            </SubNavigationLink>
                        </SubNavigationHeader>
                        
                    </SubNavigation>
                    }>
                    <User
                    ellipsis
                    name={ user.name }
                    missingImage="letter"
                    />
                </MainNavigationItem>

            </MainNavigation>
        </>
    )
}
